import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String, url: String, title: String }

  open(event) {
    event.preventDefault()
    
    const imageModal = document.getElementById('image-modal')
    const modalImage = imageModal.querySelector('#modal-image')
    const modalTitle = imageModal.querySelector('#modal-title')
    
    modalImage.src = this.urlValue
    modalImage.alt = this.titleValue || 'Gallery image'
    modalTitle.textContent = this.titleValue || ''
    
    imageModal.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  show(event) {
    event.preventDefault()

    const modalId = this.idValue
    const modal = document.getElementById(modalId)

    if (!modal) {
      console.error(`Modal with id '${modalId}' not found`)
      return
    }

    // Update fallback URL if this is a fallback modal
    if (modalId === 'fallback-modal') {
      const fallbackUrl = event.currentTarget.dataset.fallbackUrl
      this.updateFallbackModal(modal, fallbackUrl)
    }

    // Reload turbo frames in guest services location modals to ensure fresh filtered data
    if (modalId === 'arrive-at-modal' || modalId === 'depart-from-modal') {
      const frameId = modalId === 'arrive-at-modal' ? 'arrive-at-locations' : 'depart-from-locations'
      const turboFrame = modal.querySelector(`turbo-frame#${frameId}`)
      if (turboFrame && turboFrame.src) {
        turboFrame.reload()
      }
    }

    modal.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }

  hide(event) {
    event.preventDefault()
    const modal = event.currentTarget.closest('.modal')
    if (modal) {
      modal.classList.add('hidden')
      document.body.classList.remove('overflow-hidden')
    } else {
      // Fallback: try to find the modal via the controller's element
      if (this.element) {
        this.element.classList.add('hidden')
        document.body.classList.remove('overflow-hidden')
      } else {
        console.error('Modal element not found. Ensure the modal has class "modal" or is the controller element.')
      }
    }
  }

  hideById(event) {
    const modalId = event.target.dataset.modalId
    const modal = document.getElementById(modalId)
    if (modal) {
      modal.classList.add('hidden')
      document.body.classList.remove('overflow-hidden')
    }
  }

  hideOnBackdrop(event) {
    if (event.target === event.currentTarget) {
      this.hide(event)
    }
  }

  updateFallbackModal(modal, fallbackUrl) {
    const continueButton = modal.querySelector('[data-fallback-continue]')
    if (continueButton && fallbackUrl) {
      continueButton.onclick = () => {
        window.open(fallbackUrl, '_blank')
        modal.classList.add('hidden')
        document.body.classList.remove('overflow-hidden')
      }
    }
  }

  storeSelection(event) {
    // Store selection data from any selectable item in the modal
    const data = {}

    // Extract all data-selection-* attributes from the clicked element
    Object.keys(event.currentTarget.dataset).forEach(key => {
      if (key.startsWith('selection')) {
        // Convert data-selection-foo to selectionFoo, then to foo
        const cleanKey = key.replace('selection', '').toLowerCase()
        data[cleanKey] = event.currentTarget.dataset[key]
      }
    })

    this.selectedData = data
  }

  confirmSelection(event) {
    if (this.selectedData) {
      // Dispatch custom event with selection data
      this.dispatch("confirmed", {
        detail: this.selectedData
      })
    }

    // Close modal
    this.hide(event)
  }
}
